function initializeMultipleCarousel() {
    $(".multiple-carousel").slick({
        accessibility: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        variableWidth: true,
        responsive: [{
            breakpoint: 1535,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1
            }
        }]
    })
}

function initializeSingleCarousel() {
    $('.carousel-images').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        centerMode: true,
        asNavFor: '.carousel-info',
        infinite: true,
        variableWidth: true,
    });

    $('.carousel-info').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.carousel-images',
        fade: true,
        infinite: true,
    });
}

$(document).ready(function () {
    initializeMultipleCarousel()
    initializeSingleCarousel()
});
